import { useEffect, useState } from "react";

/**
 * A value that settles before it is used.
 *
 * For search boxes that drive a request: the input must update on every keystroke to stay
 * responsive, and the API must not. Without this, typing a six-character address fragment
 * is six queries, five of them already stale when they land — and because they can arrive
 * out of order, the list can settle on the results for a prefix of what is in the box.
 */
export function useDebounce<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
